(function (global) {
  'use strict';
  if (global.ArtworkUpload) return;
  function ext(name) { return String(name || '').split('.').pop().toLowerCase(); }
  function create(config, deps) {
    deps = deps || global;
    if (!/^https:\/\/[^/]+$/.test(config.workerBase)) throw new Error('Invalid workerBase');
    var cached = null, pending = null, seq = 0, active = 0, cancelCurrent = null, currentXHR = null;
    var current = null, good = null, attached = null, listeners = [];
    var state = {busy: false, progress: 0, status: '', phase: 'idle', preview: null, artwork: null};
    function designId() {
      if (deps.crypto.randomUUID) return deps.crypto.randomUUID().replace(/-/g, '').slice(0,24).toUpperCase();
      var bytes = new Uint8Array(12); deps.crypto.getRandomValues(bytes);
      return Array.from(bytes, function (b) { return b.toString(16).padStart(2,'0'); }).join('').toUpperCase();
    }
    function publish() {
      state.busy = active > 0; state.preview = current; state.artwork = attached;
      listeners.slice().forEach(function (fn) { try { fn(Object.assign({}, state)); } catch (_) {} });
    }
    function release(snap) { if (snap && snap.blob) deps.URL.revokeObjectURL(snap.blob); }
    function fresh(t) { return t && t.expiresAt - Date.now() > 30000; }
    function ticket() {
      return deps.fetch(config.workerBase + '/upload/ticket', {method: 'POST'})
        .then(function (r) { if (!r.ok) throw new Error('Ticket unavailable'); return r.json(); })
        .then(function (j) {
          if (!j || !j.ticket) throw new Error('Ticket unavailable');
          return {ticket: j.ticket, expiresAt: Date.now() + (j.expires_in || 300) * 1000};
        });
    }
    function prime() {
      if (fresh(cached) || pending) return;
      pending = ticket().then(function (t) { cached = t; }).catch(function () {}).finally(function () { pending = null; });
    }
    function take() {
      return Promise.resolve(pending).then(function () {
        if (fresh(cached)) { var t = cached.ticket; cached = null; return t; }
        cached = null;
        return ticket().then(function (t) { return t.ticket; });
      });
    }
    function send(file, token, mine) {
      return new Promise(function (resolve, reject) {
        if (mine !== seq) { reject(new Error('Superseded')); return; }
        var xhr = new deps.XMLHttpRequest(), done = false;
        currentXHR = xhr;
        function finish(err, value) { if (done) return; done = true; if (currentXHR === xhr) currentXHR = null; err ? reject(err) : resolve(value); }
        xhr.upload.addEventListener('progress', function (e) {
          if (mine === seq && e.lengthComputable) {
            state.progress = Math.min(95, Math.round(e.loaded / e.total * 100)); publish();
          }
        });
        xhr.addEventListener('load', function () {
          var j; try { j = JSON.parse(xhr.responseText); } catch (_) {}
          if (xhr.status === 200 && j && typeof j.url === 'string' && typeof j.key === 'string') {
            finish(null, j); return;
          }
          var e = new Error('Upload failed'); e.ticketInvalid = xhr.status === 401; finish(e);
        });
        ['error', 'abort', 'timeout'].forEach(function (event) {
          xhr.addEventListener(event, function () { finish(new Error('Upload ' + event)); });
        });
        xhr.open('POST', config.workerBase + '/upload?filename=' + encodeURIComponent(file.name));
        xhr.timeout = 120000;
        xhr.setRequestHeader('X-Upload-Ticket', token);
        xhr.setRequestHeader('Content-Type', file.type || 'application/octet-stream');
        xhr.send(file);
      });
    }
    function select(file) {
      if (!file) return Promise.resolve();
      if (config.acceptExts.indexOf(ext(file.name)) < 0 || file.size > config.maxBytes || file.size <= 0) {
        state.status = config.i18n.invalid + (attached ? ' ' + config.i18n.failedPrevious.replace('{name}', attached.name) : '');
        if (!active) state.phase = 'failed'; publish(); return Promise.resolve(false);
      }
      var mine = ++seq;
      if (cancelCurrent) cancelCurrent();
      if (current !== good) release(current);
      current = {name: file.name, ext: ext(file.name), size: file.size,
        blob: config.previewExts.indexOf(ext(file.name)) >= 0 ? deps.URL.createObjectURL(file) : null};
      active++; state.progress = 0; state.status = config.i18n.uploading; state.phase = 'uploading'; publish();
      var settled = false;
      function settle() { if (settled) return; settled = true; active--; publish(); }
      var cancelResolve;
      var cancelled = new Promise(function (resolve) { cancelResolve = resolve; });
      cancelCurrent = function () { if (currentXHR) currentXHR.abort(); settle(); cancelResolve(false); };
      var work = take().then(function (t) { return send(file, t, mine); }).catch(function (e) {
        if (e.ticketInvalid && mine === seq) return ticket().then(function (t) { return send(file, t.ticket, mine); });
        throw e;
      }).then(function (result) {
        if (mine !== seq) return false;
        var nextArtwork = {url: result.url, key: result.key, name: file.name,
          designId: config.designPrefix + '-' + designId()};
        if (good !== current) release(good);
        good = current;
        attached = nextArtwork;
        state.progress = 100; state.status = config.i18n.complete; state.phase = 'complete'; publish(); return true;
      }).catch(function () {
        if (mine !== seq) return false;
        if (current !== good) release(current);
        current = good;
        state.status = attached ? config.i18n.failedPrevious.replace('{name}', attached.name) : config.i18n.failedEmpty;
        state.phase = 'failed';
        publish(); return false;
      }).finally(settle);
      return Promise.race([work, cancelled]);
    }
    return {prime: prime, select: select, getState: function () { return Object.assign({}, state); },
      subscribe: function (fn) { listeners.push(fn); fn(Object.assign({}, state)); },
      destroy: function () { seq++; if (cancelCurrent) cancelCurrent(); if (current !== good) release(current); release(good); current = good = null; listeners = []; }};
  }
  global.ArtworkUpload = {create: create, extension: ext};
}(window));
